import { Grid } from '@material-ui/core';
import { Checkbox, FormControlLabel, Icons, Typography } from '@nutrien/cxp-components';
import React from 'react';

import signandStampStyles from '../SignAndStamp/SignAndStamp.styles';

interface Props {
  disableCheckedCheckbox: boolean;
  isSaveCheckDisable: boolean;
  isChecked: boolean;
  handleChange: (val: React.ChangeEvent<HTMLInputElement>) => void;
  openAlert: boolean;
  isUserConsentEnable: boolean;
  setOpenUserConsent: (val: boolean) => void;
}
const UserConsentMessage: React.FC<Props> = ({
  disableCheckedCheckbox,
  isSaveCheckDisable,
  isChecked,
  openAlert,
  handleChange,
  isUserConsentEnable,
  setOpenUserConsent,
}) => {
  const classes = signandStampStyles();
  const label = (
    <Grid item container>
      <Typography color="textPrimary" variant="body1" className={classes.content}>
        Please review
      </Typography>
      {!isUserConsentEnable && (
        <Typography color="textSecondary" className={classes.spanMsgDisable}>
          User Consent
        </Typography>
      )}
      {isUserConsentEnable && (
        <Typography
          color="primary"
          className={classes.spanMsg}
          onClick={() => setOpenUserConsent(true)}
          data-testid="user-consent-text"
        >
          User Consent
        </Typography>
      )}
      <Typography color="textPrimary" variant="body1" className={classes.content}>
        for saving Signature and Stamp Image
      </Typography>
    </Grid>
  );
  return (
    <Grid item className={classes.floatLeftGrid}>
      <Grid container className={classes.checkboxGrid}>
        {disableCheckedCheckbox ? (
          <FormControlLabel
            control={
              <Checkbox
                disabled={true}
                color="primary"
                checked={true}
                className={classes.checkBoxUserConsent}
              />
            }
            label={label}
          />
        ) : (
          <FormControlLabel
            control={
              <Checkbox
                disabled={isSaveCheckDisable}
                color="primary"
                checked={isChecked}
                onChange={e => handleChange(e)}
                className={classes.checkBoxUserConsent}
                inputProps={{
                  'data-testid': 'save-for-future-checkbox',
                }}
              />
            }
            label={label}
          />
        )}
      </Grid>
      {openAlert && (
        <Grid className={classes.errorGrid}>
          <Icons.AlertCircleIcon color="error" />
          <Typography color="error" variant="body2">
            Complete reading User Consent
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};

export default UserConsentMessage;
